export const PRODUCT_ACTION="PRODUCT_ACTION"
export const OBJECTIVE_ACTION="OBJECTIVE_ACTION"
export const TONE_ACTION="TONE_ACTION"
export const SELLING_POINT_ACTION="SELLING_POINT_ACTION"
export const DEMOGRAPHIC_ACTION="DEMOGRAPHIC_ACTION"
export const SECTION_DETAILS=" SECTION_DETAILS"